import { PlanDetail } from './../model/plandetail';
import * as Action from '../actions/paymentloan';

export interface FeatureState {
  loan: State;
}

export interface State {
  selectpayment: number;
  selectcompany: number;
  selectloanplan: number;
  gradeCarIndex: number;
  loader: boolean;

  loan: [
    { selectpayment: number; planOne: PlanDetail; planTwo: PlanDetail },
    { selectpayment: number; planOne: PlanDetail; planTwo: PlanDetail },
    { selectpayment: number; planOne: PlanDetail; planTwo: PlanDetail }
  ];
}

export const initialPlan = {
  creditCompanyName: '',
  paymentCount: 0,
  planName: '',
  firstMoney: 0,
  gankin: 0,
  bonusMonthOne: 0,
  bonusMonthTwo: 0,
  bonusPayment: 0,
  firstBonusPaymentYearMonth: new Date(),
  firstPaymentYearMonth: new Date(),
  firstBonusPaymentYM: null,
  firstPaymentYM: null,
  kappuTesuuRyou: 0,
  firstPayment: 0,
  monthlyPayment: 0,
  creditCompany: 0,
  plan: 0,
  loanPlanList: [],
  atamakin: 0,
  sueokiPrice: 0,
  payLableFirst: '',
  payLableSecond: '',
  sueokiRitsu: 0,
  zeikomiFlag: 0,
  bonusPaymentCount: 0,
  rateList: [],
  selectedRate: null,
  selectedPaymentCount: null,
  loanPaymentCountList: [],
  isSueokiPlan: false,
  shinpanCd: '',
  shinpanRenban: 0,
  systemRiyouhi: 0,
  flagdata: false,
  loading: false,
  cautionmessages: [],
  statusshowtextbox: false
};

export const initialState: State = {
  selectpayment: 1,
  selectcompany: 0,
  selectloanplan: 0,
  gradeCarIndex: 1,
  loader: false,
  loan: [
    {
      selectpayment: 1,
      planOne: { ...initialPlan },
      planTwo: { ...initialPlan }
    },
    {
      selectpayment: 1,
      planOne: { ...initialPlan },
      planTwo: { ...initialPlan }
    },
    {
      selectpayment: 1,
      planOne: { ...initialPlan },
      planTwo: { ...initialPlan }
    }
  ]
};

export function reducer(state = initialState, action: Action.Actions): State {
  switch (action.type) {
    case Action.SELECTPAYMENT: {
      const indexcar = state.gradeCarIndex - 1;
      const planone = state.loan[indexcar].planOne;
      const planTwo = state.loan[indexcar].planTwo;
      return {
        ...state,
        selectpayment: action.payload,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: action.payload,
            planOne: { ...planone },
            planTwo: { ...planTwo }
          }
        }
      };
    }

    case Action.LOAD_PAYMENT: {
      return {
        ...state,
        loader: action.payload
      };
    }
    case Action.INIT_PLANPAYMENT: {
      return {
        ...initialState
      };
    }
    case Action.SELECT_CREDITCOMPANY: {
      return {
        ...state,
        selectcompany: action.payload
      };
    }
    case Action.SELECT_PLANPAYMENT: {
      return {
        ...state,
        selectloanplan: action.payload
      };
    }

    case Action.UPDATE_PLANONE: {
      const plans = action.payload;
      const { selectedRate } = action.payload;
      const indexcar = state.gradeCarIndex - 1;
      const plantwo = state.loan[indexcar].planTwo;
      const selectloan = state.loan[indexcar].selectpayment;
      if (selectedRate) {
        if (+selectedRate.loanKbn === 18 || +selectedRate.loanKbn === 1) {
          plans.statusshowtextbox = true;
        } else {
          plans.statusshowtextbox = false;
        }
      }
      if (plans.bonusPayment === 0) {
        plans.bonusMonthOne = null;
        plans.bonusMonthTwo = null;
      }
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planOne: { ...plans },
            planTwo: { ...plantwo }
          }
        }
      };
    }

    case Action.UPDATE_PLANTWO: {
      const plans = action.payload;
      const { selectedRate } = action.payload;
      const indexcar = state.gradeCarIndex - 1;
      const planone = state.loan[indexcar].planOne;
      const selectloan = state.loan[indexcar].selectpayment;
      if (selectedRate) {
        if (+selectedRate.loanKbn === 18 || +selectedRate.loanKbn === 1) {
          plans.statusshowtextbox = true;
        } else {
          plans.statusshowtextbox = false;
        }
      }
      if (plans.bonusPayment === 0) {
        plans.bonusMonthOne = null;
        plans.bonusMonthTwo = null;
      }
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planTwo: { ...plans },
            planOne: { ...planone }
          }
        }
      };
    }

    case Action.INIT_PLANONE: {
      const indexcar = state.gradeCarIndex - 1;
      const plantwo = state.loan[indexcar].planTwo;
      const selectloan = state.loan[indexcar].selectpayment;
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planOne: { ...initialPlan },
            planTwo: { ...plantwo }
          }
        }
      };
    }

    case Action.INIT_PLANTWO: {
      const indexcar = state.gradeCarIndex - 1;
      const planOne = state.loan[indexcar].planOne;
      const selectloan = state.loan[indexcar].selectpayment;
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planOne: { ...planOne },
            planTwo: { ...initialPlan }
          }
        }
      };
    }

    case Action.DEFAULT_BONUSMONTH: {
      const indexcar = state.gradeCarIndex - 1;
      const planone = state.loan[indexcar].planOne;
      const planTwo = state.loan[indexcar].planTwo;
      const selectloan = state.loan[indexcar].selectpayment;
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planOne: {
              ...planone,
              bonusMonthOne: action.payload.defaultBonusMonth1,
              bonusMonthTwo: action.payload.defaultBonusMonth2
            },
            planTwo: {
              ...planTwo,
              bonusMonthOne: action.payload.defaultBonusMonth1,
              bonusMonthTwo: action.payload.defaultBonusMonth2
            }
          }
        }
      };
    }

    case Action.LOAD_PLANONE: {
      const indexcar = state.gradeCarIndex - 1;
      const planOne = state.loan[indexcar].planOne;
      const plantwo = state.loan[indexcar].planTwo;
      const selectloan = state.loan[indexcar].selectpayment;
      if (planOne.bonusPayment === 0) {
        planOne.bonusMonthOne = null;
        planOne.bonusMonthTwo = null;
      }
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planOne: { ...planOne, loading: action.payload },
            planTwo: { ...plantwo }
          }
        }
      };
    }

    case Action.LOAD_PLANTWO: {
      const indexcar = state.gradeCarIndex - 1;
      const planOne = state.loan[indexcar].planOne;
      const plantwo = state.loan[indexcar].planTwo;
      const selectloan = state.loan[indexcar].selectpayment;
      if (plantwo.bonusPayment === 0) {
        plantwo.bonusMonthOne = null;
        plantwo.bonusMonthTwo = null;
      }
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planOne: { ...planOne },
            planTwo: { ...plantwo, loading: action.payload }
          }
        }
      };
    }

    case Action.RESET_ERRORPAYMENTONE: {
      const indexcar = state.gradeCarIndex - 1;
      const planOne = state.loan[indexcar].planOne;
      const plantwo = state.loan[indexcar].planTwo;
      const selectloan = state.loan[indexcar].selectpayment;
      const { loanPaymentCountList } = planOne;
      let maploanPaymentCountList = [];
      if (loanPaymentCountList.length !== 0) {
        if (loanPaymentCountList[0].paymentCount !== null) {
          maploanPaymentCountList = [
            {
              defaultSueokiRitsu: 0,
              defaultSueokiRitsuKeisanZeikomiKbn: 0,
              kameitenTesuuryouRitsu: '0',
              kappuTesuuryouRitsu: '0',
              paymentCount: null
            },
            ...loanPaymentCountList
          ];
        } else {
          maploanPaymentCountList = [...loanPaymentCountList];
        }
      }
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planOne: {
              ...planOne,
              selectedPaymentCount: null,
              loanPaymentCountList: [...maploanPaymentCountList],
              payLableFirst: '',
              payLableSecond: '',
              monthlyPayment: null,
              firstPayment: null,
              paymentCount: null,
              systemRiyouhi: 0
            },
            planTwo: { ...plantwo }
          }
        }
      };
    }

    case Action.RESET_ERRORPAYMENTTWO: {
      const indexcar = state.gradeCarIndex - 1;
      const planOne = state.loan[indexcar].planOne;
      const plantwo = state.loan[indexcar].planTwo;
      const selectloan = state.loan[indexcar].selectpayment;
      const { loanPaymentCountList } = plantwo;
      let maploanPaymentCountList = [];
      if (loanPaymentCountList.length !== 0) {
        if (loanPaymentCountList[0].paymentCount !== null) {
          maploanPaymentCountList = [
            {
              defaultSueokiRitsu: 0,
              defaultSueokiRitsuKeisanZeikomiKbn: 0,
              kameitenTesuuryouRitsu: '0',
              kappuTesuuryouRitsu: '0',
              paymentCount: null
            },
            ...loanPaymentCountList
          ];
        } else {
          maploanPaymentCountList = [...loanPaymentCountList];
        }
      }
      return {
        ...state,
        loan: {
          ...state.loan,
          [indexcar]: {
            selectpayment: selectloan,
            planTwo: {
              ...plantwo,
              selectedPaymentCount: null,
              loanPaymentCountList: [...maploanPaymentCountList],
              payLableFirst: '',
              payLableSecond: '',
              monthlyPayment: null,
              firstPayment: null,
              paymentCount: null,
              systemRiyouhi: 0
            },
            planOne: { ...planOne }
          }
        }
      };
    }

    case Action.SELECT_GRADECAR: {
      return {
        ...state,
        gradeCarIndex: action.payload
      };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/payment-way/loan/reducers/paymentloan.ts